import styled from "styled-components";
import { colors } from "../../../../../theme/theme";
import { Col } from "react-bootstrap";

export const ContentBody = styled.div`
	color: ${colors.greyscale.darker_grey};
	font-size: 16px;
`;

export const CardButton = styled.div`
	button {
		width: 100%;
		padding: 8px 16px;
		background-color: transparent;
		border-radius: 4px;
		border: 1px solid ${colors.mainColors.verde_dstore};
		color: ${colors.mainColors.verde_dstore};
	}
`;

export const MultiSelectFilter = styled.div`
	.multiselect-dropdown {
		width: 100%;
		max-height: 40px;
		font-size: 14px;
	}

	.p-multiselect .p-multiselect-label.p-placeholder {
		color: ${colors.greyscale.grey2} !important;
	}

	.p-dropdown .p-dropdown-label.p-placeholder {
		color: ${colors.greyscale.grey2} !important;
		font-size: 14px;
	}

	.p-multiselect-trigger,
	.p-dropdown-trigger {
		color: ${colors.greyscale.grey2} !important;
	}
`;

export const BatchActions = styled(Col)`
	display: grid;
	grid-template-columns: 2fr 1fr;
	gap: 8px;
	place-content: center stretch;

	width: fit-content;
	max-width: 240px;
	place-self: end;

	select {
		height: 100%;
		padding: 8px 16px;
		line-height: 1;
		min-width: 100px;
	}
`;

export const ActionRibbon = styled(Col)`
	gap: 8px 4px;
	padding-bottom: 8px;

	/* Normaliza os itens da faixa de opções */
	> * {
		height: 36px;
		align-items: center;
		line-height: 1;
	}

	/* Posiciona o último elemento da faixa de opções no final */
	> *:last-child:not(.div-item-navbar, .clear-search-button) {
		margin-left: auto;
	}

	.ds-input-group {
		height: 100%;
	}

	.p-button.p-button-icon-only.p-button-rounded {
		height: 36px;
		width: 36px;
	}
`;
